// extracted by mini-css-extract-plugin
export var content = "Content-module--content--upc7A";
export var terms = "Content-module--terms--1Eb3I";